import React from 'react'

import { useTranslation } from 'react-i18next'

import { SetupButton } from 'Features/domainsManagement/components/DomainManagmentRow/DomainManagementRow.styled'

type SetupProps = {
  onClick?: () => void
  disabled?: boolean
}

export const Setup = ({ onClick, disabled }: SetupProps) => {
  const { t } = useTranslation('domainManagement')

  return (
    <SetupButton onClick={!disabled ? onClick : undefined} disabled={disabled}>
      {t('set_up')}
    </SetupButton>
  )
}
